import React from 'react'
import styles from "./style.module.scss"

const About: React.FC = () => {
   return (
      <div className={`${styles.main} d-flex`}>
         <div className={`${styles.start} card d-flex`}>
            <h1>About me</h1>
            <p>
               hii three i'm yosefus,
               <br />
               <br />
               this amazing game build by me myself and i.
               using trivia api <a href="https://opentdb.com/">opentdb.com</a>.
               <br />
               <br />
               this great and spectacular website build using react, typescript and sass, lot of brain Sweat blood and tears.
               <br />
               enjoy!
            </p>
            <div className="btnbox">
               <a href="/start">let's play</a>
               <a href="/">home</a>
               <a href="https://yosefus-portfolio.netlify.app/">my portfolio</a>
            </div>
         </div>
      </div>
   )
}

export default About